import { useState } from 'react'
import { ListGroup, ListGroupItem, Collapse } from 'reactstrap'
import AreaItem from '../AreaItem/AreaItem'
import { publishEvent } from '../../utils'
import './Area.css'

export default function Area({ area, initialCollapseState }) {
  console.log('Area rendered: ', area.name, initialCollapseState)

  const [areaState, setAreaState] = useState(initialCollapseState)

  async function areaClicked(e) {
    e.preventDefault()
    console.log('Area.areaClicked: ', area, areaState)
    const newState = (areaState === 'open' ? 'closed' : 'open')
    setAreaState(newState)
    area.state = newState
    publishEvent('SIDEBAR AREA CHANGED', area, 'Area.areaClicked')
  }

  const items = []
  if (area.items) {
    area.items.forEach((item) => {
      items.push(<AreaItem key={item.id} item={item} />)
    })
  } else {
    items.push(
      <ListGroupItem action className="area-item" key={1}>
        {'This area is currently empty'}
      </ListGroupItem>
    )
  }

  return (
    <ListGroup>
      <ListGroupItem data-cy={`area-header-${area.name.toLowerCase().replace(/ /g, '-')}`} key={area.id} active tag="a" href="" action className="area-header" onClick={(e) => areaClicked(e)}>{area.name}</ListGroupItem>
      <Collapse isOpen={areaState === 'open'}>
        {items}
      </Collapse>
    </ListGroup>
  )
}
